import { useSelector } from "react-redux";
import styled from "styled-components";
import Tile from "./Tile";
import { StockContainer as SC, Title } from "./styled";
import { localizations, getLanguage } from "./localization";

const StockContainer = styled(SC)`
  margin-left: 0rem;
`;

const PlayLine = () => {
  const { playline } = useSelector((state) => state.domino);

  return (
    <>
      <Title>{localizations.playingField[getLanguage()]}</Title>
      <StockContainer>
        {playline?.map((tile, i, a) => (
          <Tile
            tile={tile}
            key={tile.id}
            tileStyle="mixed"
            first={i === 0}
            last={i === a.length - 1}
          />
        ))}
      </StockContainer>
    </>
  );
};

export default PlayLine;
